/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteMenuItemSeparator } from "./d-theme-white-menu-item-separator";

export class DThemeWhiteMenuSidedItemSeparator extends DThemeWhiteMenuItemSeparator {}
